import * as XLSX from "xlsx";

/**
 * Column headers matching the batch upload template used in DisclosureCenterPage.
 * Order: Title | Statement Text | Company UEN | Tag Names | Is Active
 */
const EXPORT_HEADERS = [
  "Title",
  "Statement Text",
  "Company UEN",
  "Tag Names",
  "Is Active"
];

/**
 * Convert an array of disclosure objects (as returned by listDisclosures)
 * into row arrays matching the upload template columns.
 */
function disclosuresToRows(disclosures = []) {
  return disclosures.map((d) => {
    const title = d.title || "";
    const statementText = d.statement_text || "";
    const companyUen = d.company?.uen || "";
    const tagNames = (d.disclosure_tags || [])
      .map((t) => t.name || "")
      .filter(Boolean)
      .join(", ");
    const isActive =
      d.is_active === true ? "TRUE" : d.is_active === false ? "FALSE" : "TRUE";

    return [title, statementText, companyUen, tagNames, isActive];
  });
}

/**
 * Export the given disclosures array to an .xlsx file and trigger a browser download.
 *
 * @param {Array} disclosures – disclosure objects from the API (with company & disclosure_tags populated)
 * @param {string} [fileName] – optional file name (defaults to "disclosures_export.xlsx")
 */
export function exportDisclosuresToExcel(
  disclosures = [],
  fileName = "disclosures_export.xlsx"
) {
  const rows = disclosuresToRows(disclosures);
  const wsData = [EXPORT_HEADERS, ...rows];

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // Auto-size columns based on content width (approximate)
  const colWidths = EXPORT_HEADERS.map((header, colIdx) => {
    let maxLen = header.length;
    for (const row of rows) {
      const cellLen = String(row[colIdx] || "").length;
      if (cellLen > maxLen) maxLen = cellLen;
    }
    // Cap width at 80 characters
    return { wch: Math.min(maxLen + 2, 80) };
  });
  ws["!cols"] = colWidths;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Disclosures");

  XLSX.writeFile(wb, fileName);
}

export default exportDisclosuresToExcel;
